"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.launchUri = void 0;
const launchUri = (url) => {
  const SELF = '_self';
  const windowProxy = window.open(url, SELF);
  if (windowProxy) {
    return Promise.resolve(windowProxy);
  } else {
    return Promise.reject();
  }
};exports.launchUri = launchUri;